import Axios from 'axios';
import Env from '@/plugins/protokol/lib/Env'

const http = Axios.create({
  baseURL: Env.get('MEDIA_HOST'),
  timeout: 30000
});

http.defaults.withCredentials = true
http.interceptors.response.use((resp) => {
  return resp
}, (error) => {
  if (error.response !== undefined) {
    if (error.response.status == 401) {
      window.location = "/login"
    } else if (error.response.status == 200) {
      return error.response
    } else {
      return Promise.reject(error)
    }
  }
})

http.interceptors.request.use(function(config) {
  config.headers["X-Project-Uuid"] = localStorage.getItem("current_project_uuid")
  
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export default http